import { options_premium__subTitle_primaryUser } from './DomainOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserConfiguration } from 'owa-session-store';
import store from './store/store';
import { SubscriberType } from './contracts/subscriberType';
import { HMPlusBit } from 'owa-domain-connect';
import isDeprecateLegacyPremiumEnabled from './utils/isDeprecateLegacyPremiumEnabled';

var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let DomainOption: LazyOption = createLazyOption(
    {
        key: 'domain',
        titleStringKey: options_premium__subTitle_primaryUser,
        searchTermsStringKey: options_premium__subTitle_primaryUser,
        hideTitleInFullOptions: false,
        isHidden: isOptionHidden,
    },
    lazyFullModule,
    m => m.default
);

export function isOptionHidden(): boolean {
    return (
        !isFeatureEnabled('auth-domainConnect') ||
        !isFeatureEnabled('auth-PremiumDashboardApril') ||
        !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox ||
        !(store.subscriberType == SubscriberType.Primary) ||
        validateHMPlusBit() ||
        !(store.domainState.isDomainCreated || store.domainState.isDomainRemoved)
    );
}

function validateHMPlusBit(): boolean {
    return isDeprecateLegacyPremiumEnabled()
        ? false
        : (getUserConfiguration().SessionSettings.PremiumAccountOffers & HMPlusBit) == HMPlusBit;
}
export default DomainOption;
